//global variables
var poll ="";
var MobileOSArray ="";
var MobileType ="";
var i = "";
var ma ="";
var CaptureString = "";


var userAgent = String(navigator.userAgent);
var isIE = (navigator.appVersion.indexOf("MSIE") != -1) ? true : false;
var isWin = (navigator.appVersion.toLowerCase().indexOf("win") != -1) ? true : false;
var isMac = (navigator.appVersion.toLowerCase().indexOf("macintosh") != -1) ? true : false;
var is_iPhone = (navigator.appVersion.toLowerCase().indexOf("iphone") != -1) ? true : false;
var is_iPod = (navigator.appVersion.toLowerCase().indexOf("ipod") != -1) ? true : false;
var isLinux = (navigator.appVersion.toLowerCase().indexOf("linux") != -1) ? true : false;
var isAndriod = (navigator.appVersion.toLowerCase().indexOf("android") != -1) ? true : false;
var isOpera = (userAgent.indexOf("Opera") != -1) ? true : false;
var isChrome = (userAgent.indexOf("Chrome") != -1) ? true : false;
var isSafari;
if (!isChrome)
    isSafari = (userAgent.indexOf("Safari") != -1) ? true : false;
else isSafari = false;
var isFF = (userAgent.indexOf("Firefox") != -1) ? true : false;
var isAOL = (userAgent.indexOf("AOL") != -1) ? true : false;
var PluginDetect = { version: "0.7.4", handler: function(c, b, a) { return function() { c(b, a) } }, isDefined: function(b) { return typeof b != "undefined" }, isArray: function(b) { return (/array/i).test(Object.prototype.toString.call(b)) }, isFunc: function(b) { return typeof b == "function" }, isString: function(b) { return typeof b == "string" }, isNum: function(b) { return typeof b == "number" }, isStrNum: function(b) { return (typeof b == "string" && (/\d/).test(b)) }, getNumRegx: /[\d][\d\.\_,-]*/, splitNumRegx: /[\.\_,-]/g, getNum: function(b, c) { var d = this, a = d.isStrNum(b) ? (d.isDefined(c) ? new RegExp(c) : d.getNumRegx).exec(b) : null; return a ? a[0] : null }, compareNums: function(h, f, d) { var e = this, c, b, a, g = parseInt; if (e.isStrNum(h) && e.isStrNum(f)) { if (e.isDefined(d) && d.compareNums) { return d.compareNums(h, f) } c = h.split(e.splitNumRegx); b = f.split(e.splitNumRegx); for (a = 0; a < Math.min(c.length, b.length); a++) { if (g(c[a], 10) > g(b[a], 10)) { return 1 } if (g(c[a], 10) < g(b[a], 10)) { return -1 } } } return 0 }, formatNum: function(b, c) { var d = this, a, e; if (!d.isStrNum(b)) { return null } if (!d.isNum(c)) { c = 4 } c--; e = b.replace(/\s/g, "").split(d.splitNumRegx).concat(["0", "0", "0", "0"]); for (a = 0; a < 4; a++) { if (/^(0+)(.+)$/.test(e[a])) { e[a] = RegExp.$2 } if (a > c || !(/\d/).test(e[a])) { e[a] = "0" } } return e.slice(0, 4).join(",") }, $$hasMimeType: function(a) { return function(d) { if (!a.isIE) { var c, b, e, f = a.isString(d) ? [d] : d; for (e = 0; e < f.length; e++) { if (/[^\s]/.test(f[e]) && (c = navigator.mimeTypes[f[e]]) && (b = c.enabledPlugin) && (b.name || b.description)) { return c } } } return null } }, findNavPlugin: function(l, e, c) { var j = this, h = new RegExp(l, "i"), d = (!j.isDefined(e) || e) ? /\d/ : 0, k = c ? new RegExp(c, "i") : 0, a = navigator.plugins, g = "", f, b, m; for (f = 0; f < a.length; f++) { m = a[f].description || g; b = a[f].name || g; if ((h.test(m) && (!d || d.test(RegExp.leftContext + RegExp.rightContext))) || (h.test(b) && (!d || d.test(RegExp.leftContext + RegExp.rightContext)))) { if (!k || !(k.test(m) || k.test(b))) { return a[f] } } } return null }, getMimeEnabledPlugin: function(a, e) { var d = this, b, c = new RegExp(e, "i"); if ((b = d.hasMimeType(a)) && (b = b.enabledPlugin) && (c.test(b.description || "") || c.test(b.name || ""))) { return b } return 0 }, getPluginFileVersion: function(f, b) { var h = this, e, d, g, a, c = -1; if (h.OS > 2 || !f || !f.version || !(e = h.getNum(f.version))) { return b } if (!b) { return e } e = h.formatNum(e); b = h.formatNum(b); d = b.split(h.splitNumRegx); g = e.split(h.splitNumRegx); for (a = 0; a < d.length; a++) { if (c > -1 && a > c && d[a] != "0") { return b } if (g[a] != d[a]) { if (c == -1) { c = a } if (d[a] != "0") { return b } } } return e }, AXO: window.ActiveXObject, getAXO: function(a) { var d = null, c, b = this; try { d = new b.AXO(a) } catch (c) { } return d }, convertFuncs: function(g) { var a, h, f, b = /^[\$][\$]/, d = {}, c = this; for (a in g) { if (b.test(a)) { d[a] = 1 } } for (a in d) { try { h = a.slice(2); if (h.length > 0 && !g[h]) { g[h] = g[a](g); delete g[a] } } catch (f) { } } }, initScript: function() { var c = this, a = navigator, d = "/", h = a.userAgent || "", f = a.vendor || "", b = a.platform || "", g = a.product || ""; c.OS = (/win/i).test(b) ? 1 : ((/mac/i).test(b) ? 2 : ((/linux/i).test(b) ? 3 : 4)); c.convertFuncs(c); c.isIE = new Function("return " + d + "*@cc_on!@*" + d + "false")(); c.verIE = c.isIE && (/MSIE\s*(\d+\.?\d*)/i).test(h) ? parseFloat(RegExp.$1, 10) : null; c.ActiveXEnabled = false; if (c.isIE) { var e, i = ["Msxml2.XMLHTTP", "Msxml2.DOMDocument", "Microsoft.XMLDOM", "ShockwaveFlash.ShockwaveFlash", "TDCCtl.TDCCtl", "Shell.UIHelper", "Scripting.Dictionary", "wmplayer.ocx"]; for (e = 0; e < i.length; e++) { if (c.getAXO(i[e])) { c.ActiveXEnabled = true; break } } c.head = c.isDefined(document.getElementsByTagName) ? document.getElementsByTagName("head")[0] : null } c.isGecko = (/Gecko/i).test(g) && (/Gecko\s*\/\s*\d/i).test(h); c.verGecko = c.isGecko ? c.formatNum((/rv\s*\:\s*([\.\,\d]+)/i).test(h) ? RegExp.$1 : "0.9") : null; c.isSafari = (/Safari\s*\/\s*\d/i).test(h) && (/Apple/i).test(f); c.isChrome = (/Chrome\s*\/\s*(\d[\d\.]*)/i).test(h); c.verChrome = c.isChrome ? c.formatNum(RegExp.$1) : null; c.isOpera = (/Opera\s*[\/]?\s*(\d+\.?\d*)/i).test(h); c.verOpera = c.isOpera && ((/Version\s*\/\s*(\d+\.?\d*)/i).test(h) || 1) ? parseFloat(RegExp.$1, 10) : null }, init: function(c) { var b = this, a, c; if (!b.isString(c)) { return -3 } if (c.length == 1) { b.getVersionDelimiter = c; return -3 } c = c.toLowerCase().replace(/\s/g, ""); a = b[c]; if (!a || !a.getVersion) { return -3 } b.plugin = a; if (!b.isDefined(a.installed)) { a.installed = a.version = a.version0 = a.getVersionDone = null; a.$ = b; a.pluginName = c } b.garbage = false; if (b.isIE && !b.ActiveXEnabled) { if (a !== b.java) { return -2 } } return 1 }, $$isMinVersion: function(a) { return function(h, g, d, c) { var e = a.init(h), f, b = -1; if (e < 0) { return e } f = a.plugin; g = a.formatNum(a.isNum(g) ? g.toString() : (a.isStrNum(g) ? a.getNum(g) : "0")); if (f.getVersionDone != 1) { f.getVersion(d, c); if (f.getVersionDone === null) { f.getVersionDone = 1 } } a.cleanup(); if (f.installed !== null) { b = f.installed <= 0.5 ? f.installed : (f.version === null ? 0 : (a.compareNums(f.version, g, f) >= 0 ? 1 : -1)) } return b } }, getVersionDelimiter: ",", $$getVersion: function(a) { return function(g, d, c) { var e = a.init(g), f, b; if (e < 0) { return null }; f = a.plugin; if (f.getVersionDone != 1) { f.getVersion(d, c); if (f.getVersionDone === null) { f.getVersionDone = 1 } } a.cleanup(); b = (f.version || f.version0); return b ? b.replace(a.splitNumRegx, a.getVersionDelimiter) : b } }, cleanup: function() { }, flash: { mimeType: ["application/x-shockwave-flash", "application/futuresplash"], progID: "ShockwaveFlash.ShockwaveFlash", classID: "clsid:D27CDB6E-AE6D-11CF-96B8-444553540000", getVersion: function() { var b = function(i) { if (!i) { return null } var e = /[\d][\d\,\.\s]*[rRdD]{0,1}[\d\,]*/.exec(i); return e ? e[0].replace(/[rRdD\.]/g, ",").replace(/\s/g, "") : null }; var d, h = this, f = h.$, j, g, k = null, c = null, a = null; if (!f.isIE) { d = f.findNavPlugin("Flash"); if (d && d.description && f.hasMimeType(h.mimeType)) { k = b(d.description) } if (k) { k = f.getPluginFileVersion(d, k) } } else { for (g = 15; g > 2; g--) { c = f.getAXO(h.progID + "." + g); if (c) { a = g.toString(); break } } if (a == "6") { try { c.AllowScriptAccess = "always" } catch (j) { return "6,0,21,0" } } try { k = b(c.GetVariable("$version")) } catch (j) { } if (!k && a) { k = a } } h.installed = k ? 1 : -1; h.version = f.formatNum(k); return true } }, shockwave: { mimeType: "application/x-director", progID: "SWCtl.SWCtl", classID: "clsid:166B1BCA-3F9C-11CF-8075-444553540000", getVersion: function() { var a = null, b = null, g, f, d = this, c = d.$; if (!c.isIE) { f = c.findNavPlugin("Shockwave\\s*for\\s*Director"); if (f && f.description && c.hasMimeType(d.mimeType)) { a = c.getNum(f.description) } if (a) { a = c.getPluginFileVersion(f, a) } } else { try { b = c.getAXO(d.progID).ShockwaveVersion("") } catch (g) { } if (c.isString(b) && b.length > 0) { a = c.getNum(b) } else { if (c.getAXO(d.progID + ".8")) { a = "8" } else { if (c.getAXO(d.progID + ".7")) { a = "7" } else { if (c.getAXO(d.progID + ".1")) { a = "6" } } } } } d.installed = a ? 1 : -1; d.version = c.formatNum(a) } }, silverlight: { mimeType: "application/x-silverlight", progID: "AgControl.AgControl", digits: [9, 20, 9, 12, 31], getVersion: function() { var e = this, c = e.$, k = document, i = null, b = null, f = null, h = true, a = [1, 0, 1, 1, 1], u = [1, 0, 1, 1, 1], j = function(d) { return (d < 10 ? "0" : "") + d.toString() }, n = function(s, d, v, w, t) { return (s + "." + d + "." + v + j(w) + j(t) + ".0") }, o = function(s, d, t) { return r(s, (d == 0 ? t : u[0]), (d == 1 ? t : u[1]), (d == 2 ? t : u[2]), (d == 3 ? t : u[3]), (d == 4 ? t : u[4])) }, r = function(w, t, s, y, x, v) { var v; try { return w.IsVersionSupported(n(t, s, y, x, v)) } catch (v) { } return false }; if (!c.isIE) { var g; if (c.hasMimeType(e.mimeType)) { g = c.isGecko && c.compareNums(c.verGecko, c.formatNum("1.6")) <= 0; if (c.isGecko && g) { h = false } f = c.findNavPlugin("Silverlight.*Plug-?in", 0); if (f && f.description) { i = c.formatNum(f.description) } if (i) { u = i.split(c.splitNumRegx); if (parseInt(u[2], 10) >= 30226 && parseInt(u[0], 10) < 2) { u[0] = "2" } i = u.join(",") } } e.installed = f && h && i ? 1 : (f && h ? 0 : (f ? -0.2 : -1)) } else { b = c.getAXO(e.progID); var m, l, q; if (b && r(b, a[0], a[1], a[2], a[3], a[4])) { for (m = 0; m < e.digits.length; m++) { q = u[m]; for (l = q + (m == 0 ? 0 : 1); l <= e.digits[m]; l++) { if (o(b, m, l)) { h = true; u[m] = l } else { break } } if (!h) { break } } if (h) { i = n(u[0], u[1], u[2], u[3], u[4]) } } e.installed = b && h && i ? 1 : (b && h ? 0 : (b ? -0.2 : -1)) } e.version = c.formatNum(i) } }, zz: 0 }; PluginDetect.initScript();
var xList='';
var LocalIP='';

export function isMobile() {
    MobileOSArray = new Array();
    MobileType = new Array();

    MobileType = ["mobile", "Mobile"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["palm", "Palm"];
    MobileOSArray.push(MobileType);

    MobileType = ["symbian", "Symbian"];
    MobileOSArray.push(MobileType);

    MobileType = ["nokia", "Nokia"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["webos", "WebOS"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["sonyericson", "Sonyericson"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["windows phone", "Windows Phone"];
    MobileOSArray.push(MobileType);

    MobileType = ["smartphone", "Smartphone"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["windows ce", "windows CE"];
    MobileOSArray.push(MobileType);

    MobileType = ["alcatel", "Alcatel"];
    MobileOSArray.push(MobileType);

    MobileType = ["sonyeric", "Sonyeric"];
    MobileOSArray.push(MobileType);

    MobileType = ["audiovox", "Audiovox"];
    MobileOSArray.push(MobileType);

    MobileType = ["sie-", "sie"];
    MobileOSArray.push(MobileType);

    MobileType = ["lg-", " LG"];
    MobileOSArray.push(MobileType);

    MobileType = ["sec-", "SEC"];
    MobileOSArray.push(MobileType);

    MobileType = ["rover", "Rover"];
    MobileOSArray.push(MobileType);

    MobileType = ["ericsson", "Ericsson"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["sonyeric", "Sonyeric"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["ipaq", "ipaq"];
    MobileOSArray.push(MobileType);

    MobileType = ["vodaphone", "Vodaphone"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["motorola", "Motorola"];
    MobileOSArray.push(MobileType);
    
    MobileType = ["mot-", "Motorola"];
    MobileOSArray.push(MobileType);

    MobileType = ["blackberry", "Black Berry"];
    MobileOSArray.push(MobileType);

    MobileType = ["black berry", "Black Berry"];
    MobileOSArray.push(MobileType);

    MobileType = ["android", "Android"];
    MobileOSArray.push(MobileType);

    MobileType = ["iphone", "iPhone"];
    MobileOSArray.push(MobileType);

    MobileType = ["ipad", "iPad"];
    MobileOSArray.push(MobileType);

    MobileType = ["itouch", "iTouch"];
    MobileOSArray.push(MobileType);
  
    for (i = MobileOSArray.length - 1; i >= 0; i--) {
        if (userAgent.toLowerCase().indexOf(MobileOSArray[i][0]) != -1) {
            return [1, MobileOSArray[i][1]];
            //alert(MobileOSArray[i][0]+" " +MobileOSArray[i][1]);
        }
    }

    if ((screen.width < 800) || (screen.height < 600)) {
        return [1,"can not detect"];
    }

    return [0,""];
}


var isAOL = (userAgent.indexOf("AOL") != -1) ? true : false;

try {
    var body1 = document.getElementsByTagName("body");
    if (body1[0].style.behavior == '' || body1[0].style.behavior == null)
        body1[0].style.behavior = "url(#default#clientCaps)";
} catch (Error) {
}



export function getOS() {
    ma = new Array();
    ma[0] = new Array(2);
    ma[0][0] = "iPhone";
    ma[0][1] = "iPhone";

    ma[1] = new Array(2);
    ma[1][0] = "Android";
    ma[1][1] = "Android";

    ma[2] = new Array(2);
    ma[2][0] = "Black Berry";
    ma[2][1] = "Black Berry";

    ma[3] = new Array(2);
    ma[3][0] = "Windows CE";
    ma[3][1] = "Windows CE";

    ma[4] = new Array(2);
    ma[4][0] = "OpenBSD";
    ma[4][1] = "Open BSD";

    ma[5] = new Array(2);
    ma[5][0] = "SunOS";
    ma[5][1] = "Sun OS";

    ma[6] = new Array(2);
    ma[6][0] = "Linux";
    ma[6][1] = "Linux";

    ma[7] = new Array(2);
    ma[7][0] = "X11";
    ma[7][1] = "Linux";

    ma[8] = new Array(2);
    ma[8][0] = "QNX";
    ma[8][1] = "QNX";

    ma[9] = new Array(2);
    ma[9][0] = "BeOS";
    ma[9][1] = "BeOS";

    ma[10] = new Array(2);
    ma[10][0] = "OS/2";
    ma[10][1] = "OS/2";
    
    ma[11] = new Array(2);
    ma[11][0] = "Mac_PowerPC";
    ma[11][1] = "Mac OS";

    ma[12] = new Array(2);
    ma[12][0] = "Macintosh";
    ma[12][1] = "MacOSX";

    ma[13] = new Array(2);
    ma[13][0] = "Win16";
    ma[13][1] = "Windows 3.11";

    ma[14] = new Array(2);
    ma[14][0] = "Windows NT 4.0";
    ma[14][1] = "Windows NT 4.0";

    ma[15] = new Array(2);
    ma[15][0] = "WinNT4.0";
    ma[15][1] = "Windows NT 4.0";

    ma[16] = new Array(2);
    ma[16][0] = "WinNT";
    ma[16][1] = "Windows NT 4.0";

    ma[17] = new Array(2);
    ma[17][0] = "Windows NT";
    ma[17][1] = "Windows NT 4.0";

    ma[18] = new Array(2);
    ma[18][0] = "Windows 95";
    ma[18][1] = "Windows 95";

    ma[19] = new Array(2);
    ma[19][0] = "Win95";
    ma[19][1] = "Windows 95";

    ma[20] = new Array(2);
    ma[20][0] = "Windows_95";
    ma[20][1] = "Windows 95";

    ma[21] = new Array(2);
    ma[21][0] = "Windows 98";
    ma[21][1] = "Windows 98";

    ma[22] = new Array(2);
    ma[22][0] = "Win98";
    ma[22][1] = "Windows 98";

    ma[23] = new Array(2);
    ma[23][0] = "Windows ME";
    ma[23][1] = "Windows ME";

    ma[24] = new Array(2);
    ma[24][0] = "Windows NT 5.0";
    ma[24][1] = "Windows 2000";

    ma[25] = new Array(2);
    ma[25][0] = "Windows NT 5.01";
    ma[25][1] = "Windows 2000";

    ma[26] = new Array(2);
    ma[26][0] = "Windows 2000";
    ma[26][1] = "Windows 2000";

    ma[27] = new Array(2);
    ma[27][0] = "Windows NT 5.2";
    ma[27][1] = "Windows Server 2003";

    ma[28] = new Array(2);
    ma[28][0] = "Windows XP";
    ma[28][1] = "WinXP";

    ma[29] = new Array(2);
    ma[29][0] = "Windows NT 5.1";
    ma[29][1] = "WinXP";

    ma[30] = new Array(2);
    ma[30][0] = "Windows NT 6.0";
    ma[30][1] = "Windows Vista";

    ma[31] = new Array(2);
    ma[31][0] = "Windows NT 6.1";
    ma[31][1] = "Windows 7";

    ma[32] = new Array(2);
    ma[32][0] = "Windows NT 7.0";
    ma[32][1] = "Windows 7";
	
	ma[33] = new Array(2);
    ma[33][0] = "Windows NT 6.2";
    ma[33][1] = "Windows 8";

	ma[34] = new Array(2);
    ma[34][0] = "Windows NT 6.3";
    ma[34][1] = "Windows 8.1";
	
    var OS = "0";

    for (i = ma.length-1; i >= 0; i--) {
        if (userAgent.indexOf(ma[i][0]) != -1) {
            OS = ma[i][1];
            break;
        }
    }

    return OS;
}


var BrowserDetect = {
    init: function() {
        this.browser = this.searchString(this.dataBrowser) || "0";
        this.version = this.searchVersion(userAgent)
			|| this.searchVersion(navigator.appVersion)
			|| "0";
    },
    searchString: function(data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            var dataProp = data[i].prop;
            this.versionSearchString = data[i].versionSearch || data[i].identity;
            if (dataString) {
                if (dataString.indexOf(data[i].subString) != -1)
                    return data[i].identity;
            }
            else if (dataProp)
                return data[i].identity;
        }
    },
    searchVersion: function(dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    },
    dataBrowser: [
		{
		    string: userAgent,
		    subString: "Chrome",
		    identity: "Chrome"
		},
		{ string: userAgent,
		    subString: "OmniWeb",
		    versionSearch: "OmniWeb/",
		    identity: "OmniWeb"
		},
		{
		    string: navigator.vendor,
		    subString: "Apple",
		    identity: "Safari",
		    versionSearch: "Version"
		},
		{
		    prop: window.opera,
		    identity: "Opera"
		},
		{
		    string: navigator.vendor,
		    subString: "iCab",
		    identity: "iCab"
		},
		{
		    string: navigator.vendor,
		    subString: "KDE",
		    identity: "Konqueror"
		},
		{
		    string: userAgent,
		    subString: "Firefox",
		    identity: "Firefox"
		},
		{
		    string: navigator.vendor,
		    subString: "Camino",
		    identity: "Camino"
		},
		{		
		    string: userAgent,
		    subString: "Netscape",
		    identity: "Netscape"
		},
		{
		    string: userAgent,
		    subString: "MSIE",
		    identity: "IE",
		    versionSearch: "MSIE"
		},
		{
		    string: userAgent,
		    subString: "Gecko",
		    identity: "Mozilla",
		    versionSearch: "rv"
		},
		{ 		
		    string: userAgent,
		    subString: "Mozilla",
		    identity: "Netscape",
		    versionSearch: "Mozilla"
		}
	]

};

BrowserDetect.init();

export function BrowserInfo() {
    var elements = 1000;

    var regexps = {
        'Chrome': [/Chrome\/(\S+)/],
        'Safari': [/Version\/(\S+).*?Safari/],
        'IE': [/MSIE (\S+);/],
        'Opera': [
                /Opera\/.*?Version\/(\S+)/,     //Opera 10 
                /Opera\/(\S+)/,                 // Opera 9 and older 
                /Opera (\S+)/
            ],
        'Firefox': [/Firefox\/(\S+)/]
    }, re, m, browser, version;

    var BrowserObj = new Object;
    BrowserObj.Browser = "0";
    BrowserObj.FullVersion = "0";
    BrowserObj.MinorVersion = "0";
    BrowserObj.MajorVersion = "0";
    BrowserObj.Minorverlet = "0";
    BrowserObj.Version = "";

    for (browser in regexps) {
        while (re = regexps[browser].shift()) {
            if (m = userAgent.match(re)) {
                version = (m[1].match(new RegExp('[^.]+(?:\.[^.]+){0,' + --elements + '}')))[0];
                BrowserObj.Browser = browser;
                BrowserObj.FullVersion = version;

                var versionArray = version.split(".");

                BrowserObj.MinorVersion = (versionArray[1].replace(/[^0-9]/g, ''));
                BrowserObj.MajorVersion = (versionArray[0].replace(/[^0-9]/g, ''));
                BrowserObj.Version = (versionArray[0].replace(/[^0-9]/g, '')) + "." + (versionArray[1].replace(/[^0-9]/g, ''));
                BrowserObj.Minorverlet = String((versionArray[1].replace(/[0-9]/g, ''))).substring(0, 1);
                break;
            }
        }
    }
    if (BrowserObj.Browser == "0" || BrowserObj.Browser == null || BrowserObj.Browser == undefined)
        BrowserObj.Browser = BrowserDetect.browser;

    if (BrowserObj.FullVersion == "0" || BrowserObj.FullVersion == null || BrowserObj.FullVersion == undefined)
        BrowserObj.FullVersion ="r";

    if (BrowserObj.Version == "0" || BrowserObj.Version == null || BrowserObj.Version == undefined)
        BrowserObj.Version = BrowserDetect.version;

    if (BrowserObj.MajorVersion == "0" || BrowserObj.MajorVersion == null || BrowserObj.MajorVersion == undefined)
        BrowserObj.MajorVersion="r";

    if (BrowserObj.MinorVersion == "0" || BrowserObj.MinorVersion == null || BrowserObj.MinorVersion == undefined)
        BrowserObj.MinorVersion="r";

    if (BrowserObj.Minorverlet == "0" || BrowserObj.Minorverlet == null || BrowserObj.Minorverlet == undefined)
        BrowserObj.Minorverlet = "";

    return BrowserObj;
}

//alert (BrowserInfo().Version);

//fulfill fields
//

 
export function checkIframes() {
    var e = document.createElement("iframe");
    var iframes = "no";
    try {
        if (e) {
            iframes = "yes";
        }
    }
    catch (Error) {
        iframes = "no";
    }

    return iframes;
}


export function getFlashInfo() {
    var obj = new Object;
    obj.isInstalled = false;
    obj.version = "0";

    try {
        obj.isInstalled = PluginDetect.isMinVersion('Flash', '0') >= 0 ? true : false;
    } catch (e) {
        obj.isInstalled = false;
    }

    if (obj.isInstalled) {
        try {
            PluginDetect.getVersion(".");  
            obj.version = PluginDetect.getVersion('Flash');
        } catch (e) {
            obj.version = "0";
        }

        if (obj.version == null)
            obj.version = "0";
    }

    return obj;
}

export function GetFontSize() {
    var divIdName = 'myinput';
    var type = 'text';
    var text = 'getting the text size';
    var size = 0;
    try {
        var newdiv = document.createElement('input');
        newdiv.setAttribute('type', type);
        newdiv.setAttribute('id', divIdName);
        newdiv.setAttribute('outerText', text);
        size = newdiv.size;
    }
    catch (e) {
        size = 0;
    }
    return size;

}

export function getTimeZoneDiff() {
    var d = new Date()
    var diff = (-d.getTimezoneOffset() / 60);
    if (isNaN(diff))
        ver = -100;
    return diff;
}

export function getAolVersion() {
    var version = 0;
    if (isAOL) {
        try {
            version = userAgent;
            version = version.substring(version.indexOf("AOL") + 4);
            version = version.substring(0, version.indexOf(";"));
        } catch (Error) {
            version = 0;
        }
    }
    if (isNaN(version))
        version = -100;
    return version;
}

export function getConnectionType() {
    var connType = 0;
    try {
        connType = body1[0].connectionType;
        if (connType == undefined)
            connType = 0;
    } catch (Error) {
        connType = 0;
    }
    return connType;
}

export function getUserLanguage() {
    var lang;
    if (navigator.userLanguage) 
        lang = navigator.userLanguage;
    else if (navigator.language) 
        lang = navigator.language;

    return lang;
}
export function getSystemLanguage() {
    var lang;
    if (navigator.systemLanguage)
        lang = navigator.systemLanguage;
    else lang = 0;

    return lang;
}

export function detectGecko() {
    var gecko = false;

    if (navigator.product) {
        if (navigator.product == 'Gecko') {
            gecko = true;
        }
    }
    return gecko;
}
export function getGeckoBuildDateToInt() {
    var geckoBuildDate = "0";
	
	try
	{
		if (detectGecko()) {

			geckoBuildDate = navigator.buildID;
			if (isNaN(geckoBuildDate)) {
				geckoBuildDate = "0";
			}
		}
	}
	catch (ErrGeck)
	{
		geckoBuildDate = "0";
	}

    return String(geckoBuildDate).replace("'", "");
}

export function supportsDHTML() {
    var support = false;
    try {

        if (document.getElementById || document.all || document.layers || document.createElement) {
            support = true;
        }

    } catch (e) {
        support = false;
    }
    return support;

}

export function supportsXMLHttpRequest() {
    var support = false;

    try {
        if (XMLHttpRequest) {
            support = true;
        }
    } catch (Error) {
        support = false;
    }
    return support;
}
export function supportsXML() {
    var support = false;
    try {
        if (window.ActiveXObject) {
            try {
                var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
                if (xmlDoc)
                    support = true;
            } catch (Error) {
                support = false;
            }
        }
        else if (document.implementation && document.implementation.createDocument) {
            var xmlDoc = document.implementation.hasFeature("XML", null);
            support = true;
        }
    } catch (Error) {
        support = false;
    }
    return support;

}

export function getServicePack() {
    var servicepack = 0;
    if (navigator.appMinorVersion)
        servicepack = navigator.appMinorVersion;
    return servicepack;
}

export function Get_Cookie(check_name) {
    var a_all_cookies = document.cookie.split(';');
    var a_temp_cookie = '';
    var cookie_name = '';
    var cookie_value = '';
    var b_cookie_found = false;
    var i = '';

    for (i = 0; i < a_all_cookies.length; i++) {
        a_temp_cookie = a_all_cookies[i].split('=');
        cookie_name = a_temp_cookie[0].replace(/^\s+|\s+$/g, '');
        if (cookie_name == check_name) {
            b_cookie_found = true;
            if (a_temp_cookie.length > 1) {
                cookie_value = unescape(a_temp_cookie[1].replace(/^\s+|\s+$/g, ''));
            }
            return cookie_value;
            break;
        }
        a_temp_cookie = null;
        cookie_name = '';
    }
    if (!b_cookie_found) {
        return null;
    }
}

export function Set_Cookie(name, value, expires, path, domain, secure) {
    var today = new Date();
    today.setTime(today.getTime());
    if (expires) {
        expires = expires * 1000 * 60 * 60 * 24;
    }
    var expires_date = new Date(today.getTime() + (expires));
    document.cookie = name + "=" + escape(value) +
		((expires) ? ";expires=" + expires_date.toGMTString() : "") + 
		((path) ? ";path=" + path : "") +
		((domain) ? ";domain=" + domain : "") +
		((secure) ? ";secure" : "");
}

export function isEmailCrawler() {
    var emailCrawler = false;
    if (userAgent.indexOf("crawler") != -1 || userAgent.indexOf("spider") != -1 || userAgent.indexOf("bot") != -1)
        emailCrawler = true;
    return emailCrawler;

}
export function canUploadFile() {
    var uploadFile = 'Yes';

    var input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("name", "isisUploadTest");

    if (!input)
        uploadFile = 'No';
    return uploadFile;
}
export function persistentCookies() {
    var persistentcookies = 0;
    Set_Cookie('ISIStest', 'it works', '', '/', '', '');
    if (Get_Cookie('ISIStest')) {
        persistentcookies = 1;
    }

    return persistentcookies;
}
export function sessionCookies() {
    var sessioncookies = 0;
    Set_Cookie('ISIStest', 'it works', '', '/', '', '');
    if (Get_Cookie('ISIStest')) {
        sessioncookies = 1;
    }
    return sessioncookies;
}

export function getSilverlightVersion() {
    if (isMac || isAndriod || is_iPod || is_iPhone)
        return 0;

    var version = 0;

    try {
        PluginDetect.getVersion(".");  
        version = PluginDetect.getVersion('Silverlight');
    } catch (e) {
        version = 0;
    }

    if (version == null)
        version = 0;
    return version;
}
export function getSilverlightMajorVersion() {
    if (isMac || is_iPod || is_iPhone)
        return 0;
    var version = "0.0";
    try {
        PluginDetect.getVersion("."); 
        version = PluginDetect.getVersion('Silverlight');
    } catch (e) {
        version = "0.0";
    }
    if (version == undefined || version == null)
        version = "0.0";

    return version.substring(0, String(version).indexOf("."));
}

export function detectSilverlight() {
    var isInstalled = false;

    try {
        isInstalled = PluginDetect.isMinVersion('Silverlight', '0') >= 0 ? true : false;
    } catch (e) {
        isInstalled = false;
    }

    return (isInstalled) ? 1 : 0;
}


export function detectShockwave() {
    var isInstalled = false;

    try {
        isInstalled = PluginDetect.isMinVersion('Shockwave', '0') >= 0 ? true : false;
    } catch (e) {
        isInstalled = false;
    }

    return (isInstalled) ? 1 : 0;
}

export function getShockwaveVersion() {
    var version = 0;

    try {
        PluginDetect.getVersion(".");   
        version = PluginDetect.getVersion('Shockwave');
    } catch (e) {
        version = 0;
    }

    if (version == null)
        version = 0;

    return version;
}


/////


export function getWindowsMediaVersion() {
    var version = 0;

    try {
        if (window.ActiveXObject) {
            var control = null;
            try {
                control = new ActiveXObject('WMPlayer.OCX');
            } catch (e) { version = 0 }
            if (control) {
                version = control.versionInfo;
            }
        }
    } catch (e) { version = 0 }

    return version;
}
export function detectWindowsMedia() {
    var isInstalled = false;
    try {
        if (canDetectNavigatorPlugins()) {
            isInstalled = detectPlugin('Media Player');
        }
        else {
            if (window.ActiveXObject) {
                var control = null;
                try {
                    control = new ActiveXObject('WMPlayer.OCX');
                } catch (e) {
                }
                if (control) {
                    isInstalled = true;
                }
            }
        }
    } catch (e) { isInstalled = false; }

    return (isInstalled) ? 1 : 0;
}
export function isFlip4MacInstalled() {
    var isInstalled = false;

    try {
        if (canDetectNavigatorPlugins()) {
            isInstalled = detectPlugin("Flip4Mac");
        }
    } catch (e) {
        isInstalled = false;
    }
    return ((isInstalled) ? 1 : 0);
}
export function Flip4MacVersion() {
    var version = 0;

    try {
        if (isFlip4MacInstalled()) {
            for (var i = 0; i < navigator.plugins.length; i++) {
                if (navigator.plugins[i].name.indexOf("Flip4Mac") != -1) {
                    var nameString = navigator.plugins[i].name;
                    var versionArray = nameString.split(" ");
                    version = versionArray[4];
                    break;
                }
            }
        }
    } catch (e) {
        version = 0;
    }
    return version;
}

export function canDetectNavigatorPlugins() {
    if (navigator.plugins && navigator.plugins.length > 0) {
        return true;
    } else {
        return false;
    }
}


export function detectPlugin() {

    var pluginFound = false;
    try {
        var thePlugins = detectPlugin.arguments;
        if (navigator.plugins && navigator.plugins.length > 0) {
            var pluginsArrayLength = navigator.plugins.length;
            for (pluginsArrayCounter = 0; pluginsArrayCounter < pluginsArrayLength; pluginsArrayCounter++) {
                var numFound = 0;
                for (namesCounter = 0; namesCounter < thePlugins.length; namesCounter++) {
                    if ((navigator.plugins[pluginsArrayCounter].name.indexOf(thePlugins[namesCounter]) >= 0) ||
                        (navigator.plugins[pluginsArrayCounter].description.indexOf(thePlugins[namesCounter]) >= 0)) {
                        numFound++;
                    }
                }
                if (numFound == thePlugins.length) {
                    pluginFound = true;
                    break;
                }
            }
        }
    } catch (e) {
        pluginFound = true;
    }

    return pluginFound;
} 


export function supportsMSXML() {
    var support = 0;
    if (isIE) {
        var progIDs = ['Msxml2.DOMDocument.6.0', 'Msxml2.DOMDocument.5.0',
     'Msxml2.DOMDocument.4.0', 'Msxml2.DOMDocument.3.0', 'Msxml2.DOMDocument', 'Microsoft.XMLHTTP'];

        for (var i = 0; i < progIDs.length; i++) {
            try {
                var xmlDOM = new ActiveXObject(progIDs[i]);
                break;
            }
            catch (ex) {
            }
        }

        switch (i) {
            case 0:
                support = 6;
                break;
            case 1:
                support = 5;
                break;
            case 2:
                support = 4;
                break;
            case 3:
                support = 3;
                break;
            case 4:
                support = 2;
                break;
            case 5:
                support = 1;
                break;
            default: support = 0;

        }
    }
    return support;

}


export function detectCitrix() {
    var isInstalled = false;
    try {
        if (canDetectNavigatorPlugins()) {
            isInstalled = detectPlugin('Citrix ICA Client');
        }
        else {
            if (window.ActiveXObject) {
                var control = null;
                try {
                    control = new ActiveXObject('Citrix.ICAClient');
                } catch (e) {
                }
                if (control) {
                    isInstalled = true;
                }
            }
        }
    } catch (e) { isInstalled = false; }

    return (isInstalled) ? 1 : 0;
}


export function detectIpixViewer() {
    var isInstalled = false;

    try {
        if (canDetectNavigatorPlugins()) {
            isInstalled = detectPlugin('iPIX');
        }
        else {
            if (window.ActiveXObject) {
                var control = null;
                try {
                    control = new ActiveXObject('ipix.cab');
                } catch (e) {
                }
                if (control) {
                    isInstalled = true;
                }
            }
        }
    } catch (e) {
        isInstalled = false;
    }

    return (isInstalled) ? 1 : 0;
}



export function detectMapGuide() {
    var isInstalled = false;

    try {
        if (canDetectNavigatorPlugins()) {
            isInstalled = detectPlugin('Autodesk MapGuide');
        }
        else {
            if (window.ActiveXObject) {
                var control = null;
                try {
                    control = new ActiveXObject('mgaxctrl.cab');
                } catch (e) {
                }
                if (control) {
                    isInstalled = true;
                }
            }
        }
    } catch (e) {
        isInstalled = false;
    }


    return (isInstalled) ? 1 : 0;
}


export function isSVGInstalled() {
    var isInstalled = false;

    try {
        if (canDetectNavigatorPlugins()) {
            isInstalled = detectPlugin("Adobe SVG Viewer");
        }
        else {
            if (window.ActiveXObject) {
                var control = null;
                try {
                    control = new ActiveXObject('Adobe.SVGCtl');
                } catch (e) {
                }
                if (control) {
                    isInstalled = true;
                }
            }
        }
    } catch (e) {
        isInstalled = false;
    }
    return ((isInstalled) ? 1 : 0);
}

export function getxList(type,answer)
	{
		if ((answer=='')||(answer==' ')) answer = '0';
    //xList = console.log(type + ' : ' + answer);
    xList = console.log(answer + ';');
	}	
	
export	function getalldata()
	{
		var isThisMobile = isMobile();
		if (isThisMobile[0]=='1') {
			getxList('ismobile','1');//1
			getxList('os',isThisMobile[1]);//2
		}
		else {
			getxList('ismobile','0');//1
			getxList('os',getOS());//2
		}
		getxList('browser',BrowserInfo().Browser);//3
		getxList('browserfullversion',BrowserInfo().FullVersion);//4
		getxList('browserversion',BrowserInfo().Version);//5
		getxList('browsermajorversion',BrowserInfo().MajorVersion);//6
		getxList('browserminorversion',BrowserInfo().MinorVersion);//7
		getxList('browserminorvelet',BrowserInfo().Minorverlet);//8	
		getxList('browserip','0');//9
		getxList('region','0');//10
		getxList('country','0');//11
		getxList('countrycode','0');//12
		getxList('city','0');//13
		getxList('latitude','0');//14
		getxList('longitude','0');//15	
		getxList('checkiframe',checkIframes());//16
		getxList('width',screen.width);//17
		getxList('availablewidth',screen.availWidth);//18
		getxList('height',screen.height);//19
		getxList('availableheight',screen.availHeight);//20
		getxList('colordepth',screen.colorDepth);//21
		getxList('pixeldepth',screen.pixelDepth);//22
		getxList('defaultfontsize',GetFontSize());//23
		getxList('timzonedifference',getTimeZoneDiff());//24
		getxList('isflash',getFlashInfo().isInstalled);//25
		getxList('flashversion',getFlashInfo().version);//26
		getxList('aolversion',getAolVersion());//27
		getxList('connectiontype',getConnectionType());//28
		getxList('javaenabled',navigator.javaEnabled());//29
		getxList('systemlanguage',getSystemLanguage());//30
		getxList('userlanguage',getUserLanguage());//31
		getxList('gecko',detectGecko());//32
		getxList('geckoversion',getGeckoBuildDateToInt());//33
		getxList('dhtml',supportsDHTML());//34
		getxList('xml',supportsXML());//35
		getxList('xmlhttp',supportsXMLHttpRequest());//36
		getxList('servicepack',getServicePack());//37
		getxList('emailcrawler',isEmailCrawler());//38
		getxList('fileupload',canUploadFile());//39
		getxList('persistentcookies',persistentCookies());//40
		getxList('sessioncookies',sessionCookies());//41
		getxList("silverlight", getSilverlightMajorVersion());//42
		getxList("silverlightverex", getSilverlightVersion());//43
		getxList("shockwave", detectShockwave());//44
		getxList("shockwaveversion", getShockwaveVersion());//45
		getxList("IsWM",detectWindowsMedia());//46
		getxList("WMVersion",getWindowsMediaVersion());//47
		getxList("IsFlip",isFlip4MacInstalled());//48
		getxList("FlipVersion",Flip4MacVersion());//49
		getxList("isp",'0');//50
		getxList("X-Forwarded-For",'0');//51
		getxList("msxml", supportsMSXML());//52
		getxList("citrix", detectCitrix());//53
		getxList("ipixviewer", detectIpixViewer());//54
		getxList("mapguide", detectMapGuide());//55
		getxList("svgviewer", isSVGInstalled());//56
		

  }

		
export  function getresult()
   {
	var url = '';
	url="http://ws.survalidate.com/callfunction-1.php?cid="+document.getElementById('companycode').value+"&caid="+document.getElementById('caid').value+"&paid="+document.getElementById('paid').value+"&xlist="+xList+"&LocalIP="+LocalIP;
// document.write(url);
//	alert(url);

//  var head= document.getElementsByTagName('head')[0];
 //   var script= document.createElement('script');
 //    script.type= 'text/javascript';
  //  script.src= url;
  //   head.appendChild(script);

var script = document.createElement('script');
script.type = 'text/javascript';
script.src = url;
document.body.appendChild(script); 
	console.log(url);
	poll();


//	setTimeout(function(){}, 2000); 
	
	 
   }

var timeout = 1000;

poll = function () {
  setTimeout(function () {
    timeout--;
	console.log(timeout);
    if (typeof window.opstring !== 'undefined') {
      readNow();
    }
    else if (timeout > 0) {
      poll();
    }
    else { console.log("&svscore=-3");
      document.getElementById('escore').value="&svscore=-3";
    }
  }, 100);
};
 

   
   function readNow()
   {
		console.log(window.opstring);
	
		document.getElementById('escore').value = window.opstring; 
		
   }

	 //getalldata();

	 
	/*Below Code is commented & modified by khushal as dated on 15-jun-18*/
	export function getlocalIP(){
		var RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
		
		if (RTCPeerConnection) (function () {
			var rtc = new RTCPeerConnection({iceServers:[]});
			
			if (window.mozRTCPeerConnection) {      // FF needs a channel/stream to proceed
				rtc.createDataChannel('', {reliable:false});
			};
			
			rtc.onicecandidate = function (evt) {
				if (evt.candidate) grepSDP(evt.candidate.candidate);
			};
			rtc.createOffer(function (offerDesc) {
				grepSDP(offerDesc.sdp);
				rtc.setLocalDescription(offerDesc);
			}, function (e) { console.warn("offer failed", e); });
			
			
			var addrs = Object.create(null);
			addrs["0.0.0.0"] = false;
			function updateDisplay(newAddr) {
				if (newAddr in addrs) return;
				else addrs[newAddr] = true;
				var displayAddrs = Object.keys(addrs).filter(function (k) { return addrs[k]; });
				LocalIP=LocalIP+displayAddrs.join(" or perhaps ") || "n/a";
			}
			
			function grepSDP(sdp) {
				var hosts = [];
				sdp.split('\r\n').forEach(function (line) { console.log(line); // c.f. http://tools.ietf.org/html/rfc4566#page-39
					if (~line.indexOf("a=candidate")) { console.log("If");     // http://tools.ietf.org/html/rfc4566#section-5.13
						var parts = line.split(' '),        // http://tools.ietf.org/html/rfc5245#section-15.1
							addr = parts[4],
							type = parts[7];
						if (type === 'host') updateDisplay(addr);
					} else if (~line.indexOf("c=")) { console.log("elseif");       // http://tools.ietf.org/html/rfc4566#section-5.7
						var parts = line.split(' '),
							addr = parts[2];
						updateDisplay(addr);
					}
				});
			}
		})(); else {
			LocalIP=LocalIP+"-" ;
		}
	}
	
	/*export function returnIp(){
		getUserIPadd(function (ip) {
			//console.log("Local ip Address " + ip);
			document.getElementById("clientip_address").value = ip;
			//return ip;
		});
	}
	
	var ip = "";
	var onNewIP ="";
	
	export function getUserIPadd(onNewIP) { //  onNewIp - your listener function for new IPs
		//compatibility for firefox and chrome
		var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
		var pc = new myPeerConnection({
			iceServers: []
		}),
			noop = function () { },
			localIPs = {},
			ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
			key;

		function iterateIP(ip) {
			if (!localIPs[ip]) onNewIP(ip);
			localIPs[ip] = true;
		}

		//create a bogus data channel
		pc.createDataChannel("");

		// create offer and set local description
		pc.createOffer(function (sdp) {
			sdp.sdp.split('\n').forEach(function (line) {
				if (line.indexOf('candidate') < 0) return;
				line.match(ipRegex).forEach(iterateIP);
			});

			pc.setLocalDescription(sdp, noop, noop);
		}, noop);

		//listen for candidate events
		pc.onicecandidate = function (ice) {
			if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
			ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
		};
		
	}*/

	/*export function getlocalIP(
		console.log("I am here");
	);*/
	
	/*var getlocalIP = new Promise(function(resolve, reject){
		var ips = [];
		var ip_dups = {};
		
		//compatibility for firefox and chrome
		var RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
		var useWebKit = !!window.webkitRTCPeerConnection;
		
		//bypass naive webrtc blocking using an iframe
		if(!RTCPeerConnection){
			//NOTE: you need to have an iframe in the page right above the script tag
			//<iframe id="iframe" sandbox="allow-same-origin" style="display: none"></iframe>
			//<script>...getIPs called in here...
			
			var win = iframe.contentWindow;
			RTCPeerConnection = win.RTCPeerConnection || win.mozRTCPeerConnection || win.webkitRTCPeerConnection;
			useWebKit = !!win.webkitRTCPeerConnection;
		}
		
		//minimal requirements for data connection
		var mediaConstraints = { optional: [{RtpDataChannels: true}]};
		
		var servers = {iceServers: [{urls: "stun:stun.services.mozilla.com"}]};
		
		//construct a new RTCPeerConnection
		var pc = new RTCPeerConnection(servers, mediaConstraints);
		
		
		function handleCandidate(candidate){
			//match just the IP address
			var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
			var result = ip_regex.exec(candidate);

			if(!result) return;
			var ip_addr = result[1];

			//remove duplicates
			if(ip_dups[ip_addr] === undefined)
			  ips.push(ip_addr);

			ip_dups[ip_addr] = true;
		}
		
		
		//listen for candidate events
		pc.onicecandidate = function(ice){
			//skip non-candidate events
			if(ice.candidate)
			  handleCandidate(ice.candidate.candidate);
		};
		
		
		
		//create a bogus data channel
		pc.createDataChannel("");
		
		
		//create an offer sdp
		pc.createOffer(function(result){
			//trigger the stun server request
			pc.setLocalDescription(result, function(){}, function(){});
		  }, function(){});
		  
		
		//wait for a while to let everything done
		setTimeout(function(){
			//read candidate info from local description
			var lines = pc.localDescription.sdp.split('\n');

			lines.forEach(function(line){
			  if(line.indexOf('a=candidate:') === 0)
				handleCandidate(line);
			});

			resolve( ips.pop() );
		}, 1000);
		
		
	});*/	
//         getlocalIP();


/*Below code is added & commented by vivek and redefine*/
/*
export function getalljsondata() {

    var isThisMobile = isMobile();
    if (isThisMobile[0] == '1') {
        var ismobile = '1'; //1
        var os = isThisMobile[1];//2
    }
    else {
        var ismobile = '0';//1
        var os = getOS(); //2
    }


    var mydata = [
        ismobile, //1
        os, //2
        BrowserInfo().Browser, //3
        BrowserInfo().FullVersion, //4
        BrowserInfo().Version, //5
        BrowserInfo().MajorVersion, //6
        BrowserInfo().MinorVersion, //7
        BrowserInfo().Minorverlet, //8
        '0', //9
        '0', //10 
        '0', //11
        '0', //12
        '0', //13
        '0', //14
        '0', //15
        checkIframes(), //16 
        screen.width, //17
        screen.availWidth,//18
        screen.height,//19
        screen.availHeight,//20
        screen.colorDepth,//21
        screen.pixelDepth,// 22
        GetFontSize(), //23
        getTimeZoneDiff(), //24
        getFlashInfo().isInstalled, //25
        getFlashInfo().version, //26
        getAolVersion(), //27
        getConnectionType(), //28
        navigator.javaEnabled(), //29
        getSystemLanguage(), //30
        getUserLanguage(), //31
        detectGecko(), //32
        getGeckoBuildDateToInt(), //33
        supportsDHTML(), //34
        supportsXML(), //35
        supportsXMLHttpRequest(), //36
        getServicePack(), //37
        isEmailCrawler(), //38
        canUploadFile(), //39
        persistentCookies(), //40
        sessionCookies(), //41
        getSilverlightMajorVersion(), //42
        getSilverlightVersion(), //43
        detectShockwave(), //44
        getShockwaveVersion(), //45
        detectWindowsMedia(), //46
        getWindowsMediaVersion(), //47
        Flip4MacVersion(), //48
        isFlip4MacInstalled(), //49
        '0', //50
        '0', //51
        supportsMSXML(), //52
        detectCitrix(), //53
        detectIpixViewer(), //54
        detectMapGuide(), //55
        isSVGInstalled()]; //56
    var myJSON = JSON.stringify(mydata);
    return myJSON;

}*/


export function getalljsondata() {

    var isThisMobile = isMobile();
    if (isThisMobile[0] == '1') {
        var ismobile = '1'; //1
        var os = isThisMobile[1];//2
    }
    else {
        var ismobile = '0';//1
        var os = getOS(); //2
    }


    var mydata = [
        ismobile, //1
        os, //2
        BrowserInfo().Browser, //3
        BrowserInfo().FullVersion, //4
        BrowserInfo().Version, //5
        BrowserInfo().MajorVersion, //6
        BrowserInfo().MinorVersion, //7
        BrowserInfo().Minorverlet, //8
        checkIframes(), //9 
        screen.width, //10
        screen.availWidth,//11
        screen.height,//12
        screen.availHeight,// 13
        screen.colorDepth,//14
        screen.pixelDepth,// 15
        GetFontSize(), //16
        getTimeZoneDiff(), //17
        getFlashInfo().isInstalled, //18
        getFlashInfo().version, //19
        getAolVersion(), //20
        getConnectionType(), //21
        navigator.javaEnabled(), //22
        getSystemLanguage(), //23
        getUserLanguage(), //24
        detectGecko(), //25
        getGeckoBuildDateToInt(), //26
        supportsDHTML(), //27
        supportsXML(), //28
        supportsXMLHttpRequest(), //29
        getServicePack(), //30
        isEmailCrawler(), //31
        canUploadFile(), //32
        persistentCookies(), //33
        sessionCookies(), //34
        getSilverlightMajorVersion(), //35
        getSilverlightVersion(), //36
        detectShockwave(), //37
        getShockwaveVersion(), //38
        detectWindowsMedia(), //39
        getWindowsMediaVersion(), //40
        Flip4MacVersion(), //41
        isFlip4MacInstalled(), //42
        supportsMSXML(), //43
        detectCitrix(), //44
        detectIpixViewer(), //45
        detectMapGuide(), //46
        isSVGInstalled()]; //47
    // return mydata;
    var myJSON = JSON.stringify(mydata);
    return myJSON;
}
/*Above code is added & commented by vivek and redefine*/

     //getresult();

	